import LoadingIndicator from 'modules/common/LoadingIndicator';
import PropTypes from 'prop-types';
import React, {lazy, Suspense} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'gatsby';
import NewDesignButton from 'modules/common/NewDesignButton';
import closeIconBlack from 'theme/assets/images/close-icon-black.svg';
import {fixedbar, links, barcontent} from './style.scss';

const SidebarButton = lazy(() => import('../SidebarButton'));

const HeroHeader = (props) => (
  <div className={`relative ${fixedbar} bg-near-white w-100 tc`}>
    <div className={`flex items-center justify-center h-100 ${barcontent}`}>
      <h1 className="ma0 pv2-ns pv3 f5 f4-m f3-ns">{props.title}</h1>
      <div className={`flex items-center ${links}`}>
        <NewDesignButton
          className="lh-copy fw6 bg-blue bg-animate hover-bg-dark-blue"
          link="https://discord.gg/qmVqWbm"
          external
        >
          <FormattedMessage id="do_you_need_help" />
        </NewDesignButton>
        <Link
          to={
            props.isDegree
              ? `/degrees/${props.trackSlug}`
              : `/${props.trackSlug}`
          }
          className="lh-solid mr4"
        >
          <img src={closeIconBlack} alt="Close Icon" width="18" height="18" />
        </Link>
      </div>
    </div>
    <Suspense fallback={<LoadingIndicator />}>
      <SidebarButton />
    </Suspense>
  </div>
);

HeroHeader.propTypes = {
  title: PropTypes.string,
  trackSlug: PropTypes.string,
  isDegree: PropTypes.bool.isRequired,
};

export default HeroHeader;
